import React, { useState, useEffect } from "react"; // Import React and hooks
import Swal from "sweetalert2";
import "./custom.css";

// Modal component
function Modal({ show, data, onClose, searchType, searchQuery }) {
  const [activeTab, setActiveTab] = useState("pending");

  useEffect(() => {
    const handleClickOutside = (event) => {
      const modal = document.getElementById("modal");
      if (modal && !modal.contains(event.target)) {
        onClose();
      }
    };

    if (show) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [show, onClose]);

  if (!show) return null;

  const getColumns = () => {
    if (searchType === "vehicle") {
      return ["SN", "Reference", "License", "Location", "Offence", "Charge", "Penalty", "Status", "Issued Date"];
    } else if (searchType === "license") {
      return ["SN", "Reference", "Vehicle", "Location", "Offence", "Charge", "Penalty", "Status", "Issued Date"];
    } else if (searchType === "reference") {
      return ["SN", "Vehicle", "License", "Location", "Offence", "Charge", "Penalty", "Status", "Issued Date"];
    }
  };

  const getColumns_history = () => {
    if (searchType === "vehicle") {
      return ["SN", "Reference", "License", "Location", "Offence", "Charge", "Penalty", "Status", "Paid Date"];
    } else if (searchType === "license") {
      return ["SN", "Reference", "Vehicle", "Location", "Offence", "Charge", "Penalty", "Status", "Paid Date"];
    }
  };

  const getDataFields = (item, index) => {
    if (searchType === "vehicle") {
      return [index + 1, item.reference, item.licence, item.location, item.offence, item.charge, item.penalty, item.status, item.issued_date];
    } else if (searchType === "license") {
      return [index + 1, item.reference, item.vehicle, item.location, item.offence, item.charge, item.penalty, item.status, item.issued_date];
    } else if (searchType === "reference") {
      return [index + 1, item.vehicle, item.licence, item.location, item.offence, item.charge, item.penalty, item.status, item.issued_date];
    }
  };

  const getDataFields_history = (item, index) => {
    if (searchType === "vehicle") {
      return [index + 1, item.reference, item.licence, item.location, item.offence, item.charge, item.penalty, item.status, item.paydate];
    } else if (searchType === "license") {
      return [index + 1, item.reference, item.vehicle, item.location, item.offence, item.charge, item.penalty, item.status, item.paydate];
    }
  };

  const getLicenceStatusColumns = () => {
    return ["Licence Number", "Issued Date", "Expire Date", "Points", "Licence Status", "Suspension Status", "Suspension Count"];
  };

  const getLicenceStatusData = () => {
    return [
      {
        licenceNo: "N/A",
        issueDate: "N/A",
        expiryDate: "N/A",
        points: "N/A",
        licenceStatus: "N/A",
        suspensionStatus: "N/A",
        suspensionCount: "N/A",
      },
    ];
  };

  return (
    <div className="modal-overlay">
      <div className="modal xlarge" id="modal">
        <button className="close-btn" onClick={onClose}>X</button>
        <h3>{`Search Results For ${searchType.charAt(0).toUpperCase() + searchType.slice(1)} Number ${searchQuery}`}</h3>

        <div className="tab-buttons">
          <button
            className={`tab-button ${activeTab === "pending" ? "active" : ""}`}
            onClick={() => setActiveTab("pending")}
          >
            Pending Offences
          </button>
          {searchType === "vehicle" && (
            <button
              className={`tab-button ${activeTab === "inspection" ? "active" : ""}`}
              onClick={() => setActiveTab("inspection")}
            >
              Inspection Status
            </button>
          )}
          {searchType === "license" && (
            <button
              className={`tab-button ${activeTab === "licenceStatus" ? "active" : ""}`}
              onClick={() => setActiveTab("licenceStatus")}
            >
              Licence Status
            </button>
          )}
        </div>

        {/* Pending Offence Returned Data */}
        {activeTab === "pending" && (
          <>
            {data.pending_transactions && data.pending_transactions.length > 0 ? (
              <table className="transaction-table">
                <thead>
                  <tr>
                    {getColumns().map((col, index) => (
                      <th key={index}>{col}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.pending_transactions.map((item, index) => (
                    <tr key={index}>
                      {getDataFields(item, index).map((field, i) => (
                        <td key={i}>{field}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p className="no-results">No pending offences found.</p>
            )}
          </>
        )}

        {/* Inspection Returned Data */}
        {activeTab === "inspection" && (
        <>
          {data.inspection_data && data.inspection_data.length > 0 ? (
            <table className="transaction-table uppercase-table center-text">
              <thead>
                <tr>
                  <th>Number Plate</th>
                  <th>VIR No</th>
                  <th>Valid Until</th>
                  <th>Remarks</th>
                  <th>Non-Compliant</th>
                  <th>Region</th>
                  <th>District</th>
                  <th>Final Result</th>
                </tr>
              </thead>
              <tbody>
                {data.inspection_data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.noplate}</td>
                    <td>{item.vir_no}</td>
                    <td>{item.valid_untill}</td>
                    <td>{item.remarks}</td>
                    <td>{item.prohibition_on_use}</td>
                    <td>{item.region}</td>
                    <td>{item.district}</td>
                    <td>{item.finalresult}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className="no-results center-text">No inspection data for this vehicle.</p>
          )}
        </>
      )}

        {activeTab === "licenceStatus" && (
          <>
            {getLicenceStatusData().length > 0 ? (
              <table className="transaction-table">
                <thead>
                  <tr>
                    {getLicenceStatusColumns().map((col, index) => (
                      <th key={index}>{col}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {getLicenceStatusData().map((item, index) => (
                    <tr key={index}>
                      <td>{item.licenceNo}</td>
                      <td>{item.issueDate}</td>
                      <td>{item.expiryDate}</td>
                      <td>{item.points}</td>
                      <td>{item.licenceStatus}</td>
                      <td>{item.suspensionStatus}</td>
                      <td>{item.suspensionCount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p className="no-results">No licence status data found.</p>
            )}
          </>
        )}
      </div>
    </div>
  );
}

function Body() {
  const [searchPlaceholder, setSearchPlaceholder] = useState("Search by Registration... eg. T359DTT");
  const [searchQuery, setSearchQuery] = useState("");
  const [modalData, setModalData] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [searchType, setSearchType] = useState("vehicle"); // Default search type is vehicle
  const [loading, setLoading] = useState(false); // Loading state

  const searchOptions = [
    { icon: "fa-car", text: "Search By Registration", placeholder: "Search by Registration... eg. T359DTT", type: "vehicle" },
    { icon: "fa-id-card", text: "Search By Licence", placeholder: "Search by Licence Number...", type: "license" },
    { icon: "fa-receipt", text: "Search By Reference", placeholder: "Search by Reference Number...", type: "reference" },
  ];

  const validateSearch = () => {
    if (searchType === "vehicle" && (!/^[A-Za-z0-9]{7}$/.test(searchQuery))) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Vehicle Registration Number',
        text: 'Please enter a valid vehicle number eg T849EDY.',
      });
      return false;
    }

    if (searchType === "license" && (!/^\d{10,}$/.test(searchQuery))) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid License Number',
        text: 'Please enter a valid license number with at least 10 digits. eg 4000453134',
      });
      return false;
    }

    if (searchType === "reference" && (!/^\d{12,}$/.test(searchQuery))) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Reference Number',
        text: 'Please enter a valid reference number eg 9910838966983',
      });
      return false;
    }

    return true;
  };

  const handleSearch = async () => {
    if (!searchQuery) {
      Swal.fire({
        icon: 'error',
        title: 'Input Required',
        text: 'Please enter a search term.',
      });
      return;
    }

    if (!validateSearch()) return;

    setLoading(true); // Show loader

    try {
      const response = await fetch("/api/OffenceCheck", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ [searchType]: searchQuery }),
      });
    
      // Check if the response is OK (status code 200-299)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
    
      // Parse the JSON response
      const data = await response.json();
    
      // Stop loading
      setLoading(false);
    
      // Handle the response data
      if (data.status === "success") {
        setModalData(data); // Set modal data if successful
        setModalVisible(true); // Show the modal
      } else {
        // Show error message if no results are found
        Swal.fire({
          icon: 'error',
          title: 'No Results',
          text: 'No results found for your search.',
        });
      }
    } catch (error) {
      // Stop loading in case of an error
      setLoading(false);
    
      // Log the error for debugging
      console.error("Fetch error:", error);
    
      // Show a user-friendly error message
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'Error fetching data. Please try again.',
      });
    }
  };

  return (
    <main className="body-container">
      <div className="content-container">
        <div className="navbar">
          {searchOptions.map((option, index) => (
            <React.Fragment key={index}>
              <button
                className={`nav-button ${searchType === option.type ? "active" : ""}`}
                onClick={() => {
                  setSearchPlaceholder(option.placeholder);
                  setSearchType(option.type); 
                }}
              >
                <i className={`fa ${option.icon}`}></i> {option.text}
              </button>
              {index < searchOptions.length - 1 && <span className="separator">|</span>}
            </React.Fragment>
          ))}
        </div>

        {/* Search Box */}
        <div className="search-box">
          <input
            type="text"
            placeholder={searchPlaceholder}
            className="search-input"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button className="search-button" onClick={handleSearch}>
            <i className="fas fa-search"></i> <span className="search-text">Search</span>
          </button>

        </div>
      </div>

      {/* Loader */}
      {loading && (
        <div className="loader">
          <div className="loader-bar"></div>
          <div className="loader-bar"></div>
          <div className="loader-bar"></div>
        </div>
      )}

      {/* Modal */}
      <Modal show={modalVisible} data={modalData} onClose={() => setModalVisible(false)} searchType={searchType} searchQuery={searchQuery} />
    </main>
  );
}

export default Body; // Export Body as default  